export const MatchStatus = Object.freeze({
  MATCHED: "matched",
  UNMATCHED: "unmatched",
  REJECTED: "rejected",
  PENDING: "pending",
  UNKNOWN: "unknown",
});
